import { app } from '../../../../app';
import { Controller } from './session-recording.controller';

app.component('companyManageApplicationSessionRecording', {
    bindings: {
        application: '<',
        companyDomains: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./session-recording.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/session-recording/session-recording.component.js